<template>
	<div class="story-grafiek">
		<div class="grafiek-wrapper">
			<h3>Hoe is in de afgelopen 25 jaar overgewicht bij tieners veranderd?</h3>
			<p>Geef je eigen schatting en kom erachter</p>
			<div class="knd-chart-draw" ref="overgewicht_grafiek"></div>
			<div class="knd-button" @click="grafiekButtonClick" :style="'visibility:' + grafiekStates[currentState].button">
				<span>{{ grafiekStates[currentState].button_tekst }}</span>
				<img :src="grafiekStates[currentState].button_icon()" />
			</div>
			<div class="grafiek-explain" :style="'visibility:' + grafiekStates[currentState].explain">
				<span v-html="grafiekStates[currentState].explain_tekst"></span>
				<div class="grafiek-explain-ok"  @click="grafiekExplainClick">OK</div>
			</div>
			<p class="grafiek-credit" @click='gotoLink("https://www.volksgezondheidenzorg.info/onderwerp/overgewicht/cijfers-context/trends#node-trend-overgewicht-kinderen-naar-leeftijd")'>Bron: Ministerie van Volksgezondheid en Zorg</p>
		</div>
	</div>
</template>

<script>
	import Overgewicht from './overgewicht.js';
	import { grafiekStates } from './grafiekstates.js';

	export default {
		name: 'App',
		components: {
			
		},
		data: function() {
			return {
				overgewichtGrafiek: null,
				grafiekStates: grafiekStates(),
				currentState: 4,
				overgewichtData: this.$store.state.chart_data
			}
		},
		mounted: function() {
			this.overgewichtGrafiek = new Overgewicht(this.overgewichtData, this.grafiekStates, this.$refs.overgewicht_grafiek);
			this.overgewichtGrafiek.maakGrafiek();
			
			//resize
			var rePosition;
			window.addEventListener("resize", () => {
				clearTimeout(rePosition);
				rePosition = setTimeout(() => {
					this.overgewichtGrafiek.resize();
				}, 500);
			});
		},
		methods: {
			grafiekButtonClick() {
				this.currentState = this.grafiekStates[this.currentState].button_to;
				this.overgewichtGrafiek.changeState(this.currentState);
			},
			grafiekExplainClick() {
				this.currentState = this.grafiekStates[this.currentState].explain_to;
				this.overgewichtGrafiek.changeState(this.currentState);
			},
			gotoLink(url) {
				window.open(url);
			}
		}
	}
</script>